import React from 'react'
import { connect } from "react-redux";
import {
    Chart,
    ChartArea,
    ChartSeries,
    ChartTitle,
    ChartSeriesItem,
    ChartLegend,
    ChartSeriesLabels,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxis,
    ChartValueAxisItem
} from '@progress/kendo-react-charts';
import { PropTypes } from 'prop-types';

class SitelogDashboardForm extends React.Component {

    constructor(props) {
      super(props);

    }
 
  
    render() {
            let ChartContainer = null, ChartContainer2 = null, ChartContainer3 = null
            
            if(this.props.homeStats){
                
                let AttributableTimeLoss = this.props.homeStats.attributableTimeLoss ? this.props.homeStats.attributableTimeLoss : [{loss: 0, 'code': ''}],
                BookedWorksitesLoss = this.props.homeStats.bookedTimeLoss ? this.props.homeStats.bookedTimeLoss : [],
                ActualContractHours = this.props.homeStats.actualContractHours ? this.props.homeStats.actualContractHours : [];

                ChartContainer = () => (
                    <Chart>
                        <ChartArea background="#272c33" height="350" />
                        <ChartLegend position="bottom" />
                        <ChartSeries>
                        <ChartSeriesItem  type="pie" data={AttributableTimeLoss} field="loss" categoryField="code" color="#fff">
                            <ChartSeriesLabels />
                        </ChartSeriesItem>
                        </ChartSeries>
                    </Chart>
                );

        
                ChartContainer2 = () => (
                    <Chart pannable={{ lock: 'y' }} zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}>

                        <ChartLegend position="bottom" />
                        <ChartArea background="#272c33" height="350" />
                        <ChartValueAxis>
                            <ChartValueAxisItem color="#fff" name={'worksitesNo'} minorUnit={1} majorUnit={4} title={{text:'No of Worksites'}} max={Math.max.apply(Math, BookedWorksitesLoss.map(x => x.worksitesNo)) + 3} />
                            <ChartValueAxisItem axisCrossingValue={BookedWorksitesLoss.length} color="#fff" name={'actual'} title={{text:'Minutes Lost'}} max={Math.max.apply(Math, BookedWorksitesLoss.map(x => x.actual)) + 10} />
                        </ChartValueAxis>
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem color="#fff" title={{text:'Won Week No'}} categories={BookedWorksitesLoss.map(x => x.week)} axisCrossingValue={[0, BookedWorksitesLoss.length]} labels={{ rotation: 'auto' }} />
                        </ChartCategoryAxis>
                        <ChartSeries>
                            <ChartSeriesItem  axis={'worksitesNo'} type="column" data={BookedWorksitesLoss.map(x => x.worksitesNo)} name="Number of WS" />
                            <ChartSeriesItem axis={'actual'} type="line" data={BookedWorksitesLoss.map(x => x.actual)} name="Time Loss" />
                        </ChartSeries>
                    </Chart>
                )
        
                ChartContainer3 = () => (
                    <Chart pannable={{ lock: 'y' }} zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}>
                        <ChartArea background="#272c33" height="350" />
                        <ChartLegend position="bottom" />
                        <ChartValueAxis>
                            <ChartValueAxisItem title ={{text:'Hours'}} color="#fff" />
                        </ChartValueAxis>
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={ActualContractHours.map(x => x.bookedPossessionStart)} color="#fff" baseUnit="days" labels={{ format: '{0:dd/MM/yyyy}', rotation: 'auto' }} />
                        </ChartCategoryAxis>
                        <ChartSeries>
                            <ChartSeriesItem  type="line" data={ActualContractHours.map(x => x.booked)} name="Booked Minutes"  />
                            <ChartSeriesItem  type="line" data={ActualContractHours.map(x => x.available)} name="Available Minutes" />
                            <ChartSeriesItem  type="line" data={ActualContractHours.map(x => x.actual)} name="Actual Minutes" />
                        </ChartSeries>
                    </Chart>
                )
        
            }

            if (this.props.loading) {
                return (
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0', color: '#a6b0cf'}}>
                        <div className="dash-spinner" />
                        <div style={{marginTop: 16, fontSize: 13}}>Loading dashboard...</div>
                    </div>
                );
            }

            return (

                    <div>

                        <div className="dash-section-banner">
                            <span className="mdi mdi-train dash-section-icon"></span> Worksite Statistics
                        </div>
                        <div className="row">
                        {/* {/* <!-- Column --> */} 
                        <div className="col-lg-3 col-md-6">
                            <div className="card dash-stat-card">
                                <div className="card-body">
                                    {/* <!-- Row --> */}
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h2 style={{color: 'var(--amber-primary)'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.totalWorksites}</h2>
                                            <h6>Worksites</h6>
                                        </div>
                                        <div className="col-4 text-center">
                                            <span className="mdi mdi-train dash-stat-icon"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {/* <!-- Column --> */} 
                        <div className="col-lg-3 col-md-6">
                            <div className="card dash-stat-card dash-stat-card-danger">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h2 style={{color: '#f44336'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.totalWorksitesTimeLossStart} </h2>
                                            <h6>Minutes Lost At Start</h6>
                                        </div>
                                        <div className="col-4 text-center">
                                            <span className="mdi mdi-timer-alert-outline dash-stat-icon dash-stat-icon-danger"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {/* <!-- Column --> */} 
                        <div className="col-lg-3 col-md-6">
                            <div className="card dash-stat-card dash-stat-card-danger">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h2 style={{color: '#f44336'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.totalWorksitesTimeLossEnd} </h2>
                                            <h6>Minutes Lost At End</h6>
                                        </div>
                                        <div className="col-4 text-center">
                                            <span className="mdi mdi-timer-alert-outline dash-stat-icon dash-stat-icon-danger"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {/* <!-- Column --> */} 
                        <div className="col-lg-3 col-md-6">
                            <div className="card dash-stat-card dash-stat-card-danger">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h2 style={{color: '#f44336'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.percentageTimeLoss}% </h2>
                                            <h6>Percentage Time Loss</h6>
                                        </div>
                                        <div className="col-4 text-center">
                                            <span className="mdi mdi-percent dash-stat-icon dash-stat-icon-danger"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    
                        <div className="row">
                        <div className="col-lg-8 col-md-7">
                            <div className="card">
                                <div className="card-header ctrl-log-card-header">
                                    <span className="mdi mdi-chart-areaspline ctrl-log-card-icon"></span>
                                    <h5 className="mb-0">Actual Worksite Hours vs Contract Hours</h5>
                                </div>
                                <div className="card-body">
                                
                                    <ChartContainer3 />

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <div className="card">
                                <div className="card-header ctrl-log-card-header">
                                    <span className="mdi mdi-chart-pie ctrl-log-card-icon"></span>
                                    <h5 className="mb-0">Attributable Time Loss</h5>
                                </div>
                                <div className="card-body">
                                
                                    {this.props.homeStats.attributableTimeLoss && this.props.homeStats.attributableTimeLoss.length > 0 && this.props.homeStats.attributableTimeLoss[0].code !== ''
                                        ? <ChartContainer />
                                        : <div className="ws-empty-state"><span className="mdi mdi-chart-pie"></span> No attributable time loss data</div>
                                    }

                                </div>
                            </div>
                        </div>
                        </div>

                        <div className="row">

                        <div className="col-lg-12 col-md-12">
                            <div className="card">
                                <div className="card-header ctrl-log-card-header">
                                    <span className="mdi mdi-chart-bar ctrl-log-card-icon"></span>
                                    <h5 className="mb-0">Booked Worksites vs Time Loss</h5>
                                </div>
                                <div className="card-body" style={{padding: 0}}>
                                    <div className="chart-scroll-wrapper">
                                        <div style={{minWidth: window.innerWidth <= 767 ? Math.max(600, ((this.props.homeStats.bookedTimeLoss || []).length) * 22) : 'auto'}}>
                                            <ChartContainer2 />
                                        </div>
                                        <div className="chart-scroll-fade" />
                                    </div>
                                    <div className="chart-scroll-hint">← swipe to explore →</div>
                                </div>
                            </div>
                        </div>

                        </div>


                    </div>
            )

    }

  }


  SitelogDashboardForm.propTypes = {
    
};



function mapStateToProps(state, ownProps) {
    return {
        homeStats: state.homeStats,
        loading: state.ajaxCallsInProgress > 0
    }
}

export default connect(mapStateToProps) (SitelogDashboardForm);